import React, { useMemo, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { useAuth } from '../context/AuthContext';
import { PageHeader, DarkPanel, btnOnDark } from '../components/ui';

export default function ReferFriend() {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);

  const link = useMemo(() => {
    // In the Android app, window.location.origin is the WebView's internal
    // "https://localhost" — a link friends can't open. Always share the real site.
    const base = Capacitor.isNativePlatform() ? 'https://stockxignal.com' : window.location.origin;
    const ref = user?.id != null ? `10${new Date().getFullYear()}${user.id}` : '';
    return `${base}/register?ref=${encodeURIComponent(ref || 'stockxignal')}`;
  }, [user]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      const ta = document.createElement('textarea');
      ta.value = link;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const emailShare = () => {
    const subject = encodeURIComponent('Join me on StockXignal');
    const body = encodeURIComponent(
      `I'm using StockXignal for market signals.\n\nRegister here:\n${link}\n`
    );
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  const smsShare = () => {
    const body = encodeURIComponent(`Join StockXignal: ${link}`);
    window.location.href = `sms:?&body=${body}`;
  };

  const waShare = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(`Join StockXignal: ${link}`)}`, '_blank');
  };

  const shareBtn = 'rounded-xl border border-white/10 bg-white/[0.06] py-2.5 text-sm font-semibold text-white transition hover:bg-white/[0.12]';

  return (
    <div className="pb-8">
      <PageHeader title="Refer a friend" subtitle="Share your personal registration link by email, text, or other apps." />

      <DarkPanel title="Your link" bodyClassName="space-y-4 p-4">
        <div className="flex gap-2">
          <input
            readOnly
            value={link}
            className="min-w-0 flex-1 rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2.5 text-sm text-white"
          />
          <button type="button" onClick={copy} className={`${btnOnDark} shrink-0`}>
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>

        <div className="grid grid-cols-3 gap-2">
          <button type="button" onClick={emailShare} className={shareBtn}>Email</button>
          <button type="button" onClick={smsShare} className={shareBtn}>SMS</button>
          <button type="button" onClick={waShare} className={shareBtn}>WhatsApp</button>
        </div>

        <p className="text-xs leading-relaxed text-slate-400">
          Friends open the link to register.
        </p>
      </DarkPanel>
    </div>
  );
}
